import { render, staticRenderFns } from "./Activitylist.vue?vue&type=template&id=4a31b9bf&scoped=true"
import script from "./Activitylist.vue?vue&type=script&lang=js"
export * from "./Activitylist.vue?vue&type=script&lang=js"
import style0 from "./Activitylist.vue?vue&type=style&index=0&id=4a31b9bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a31b9bf",
  null
  
)

export default component.exports